import React, { Component, Fragment } from 'react';
import { Translate } from 'react-redux-i18n';
import { Paginator } from 'primereact/components/paginator/Paginator';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Redirect } from 'react-router-dom';
import { css } from 'aphrodite/no-important';
import isEmpty from 'lodash/isEmpty';
import styles from './List.styles';
import './customPagination.styles';
import { ICON_TYPE } from '../../constants/icons';
import { FILTER_TYPE } from '../../constants/data';
import {
  getTagsAction,
  addFilterAction,
  removeFilterAction,
  setSortingAction,
  setCurrentTagAction,
  setCurrentCategoryAction,
  setCurrentGroupAction,
  getFilteredCategoriesAction,
  getFilteredGroupsAction,
  addTagAction,
  editTagAction,
  bulkUploadClearAction,
  addInfoAction,
  bulkUploadAction,
  addGroupAction,
  editGroupAction,
  addCategoryAction,
  downloadTagListAction,
  editCategoryAction,
  deleteTagAction,
  deleteGroupAction,
  deleteCategoryAction,
  getAreasAction,
  setCurrentAreaAction,
  selectTagAction,
  clearTagsAction,
  expandCollapseAction
} from '../../reducers/actions';
import {
  getAllUnfilteredTags,
  getFilteredCategories,
  getFilteredGroups,
  getTagsCount,
  findSelectedTag,
  getListViewColumns,
} from '../../utils/selectors';

import DataTable from '../../components/data/datatable/DataTable';

import Modal from '../../components/common/modal/Modal';
import ModalTabView from '../../components/common/modaltabview/ModalTabView';
import ModalTabPanel from '../../components/common/modaltabpanel/ModalTabPanel';

import AddButton from '../../components/inputs/addbutton/AddButton';
import Button from '../../components/inputs/button/Button';
import AddSelection from '../../components/common/addselection/AddSelection';
import AddTagForm from '../../components/forms/addtagform/AddTagForm';
import BulkUploadFileForm from '../../components/forms/bulkupload/BulkUploadFileForm';
import BulkUploadResults from '../../components/forms/bulkupload/bulkuploadresults/BulkUploadResults';
import AddGroupForm from '../../components/forms/addgroupform/AddGroupForm';
import AddCategoryForm from '../../components/forms/addcategoryform/AddCategoryForm';
import Confirm from '../../components/common/confirm/Confirm';
import Confirmation from '../../components/common/confirmation/Confirmation';
import SearchInput from '../../components/inputs/searchinput/SearchInput';
import ListItems from '../../components/common/listitems/ListItems';
import DeleteCategoryForm from '../../components/forms/deletecategoryform/DeleteCategoryForm';
import Notification from '../../components/common/notification/Notification';
import LoadingMask from '../../components/common/LoadingMask.js';
import ErrorBoundary from '../../components/common/errorboundary/ErrorBoundary';

export class List extends Component {
  state = {
    showAddModal: false,
    showAddTagModal: false,
    showEditTagModal: false,
    showAddGroupModal: false,
    showAddCategoryModal: false,
    showAddBulkUploadModal: false,
    showResultsBulkUploadModal: false,
    showDeleteTagModal: false,
    showEditCategoryListModal: false,
    showEditGroupListModal: false,
    showEditCategoryModal: false,
    showEditGroupModal: false,
    showDeleteGroupModal: false,
    showDeleteCategoryModal: false,
    showFilterConfirmationModal: false,
    filterChangeText: '',
    filterToAdd: {},
    categorySearchValue: '',
    groupSearchValue: '',
    pageSize: 25,
    pageValue: 1,

    totalRows: 0,
    first: 0, 
    rows: 25,
    page: 0,
  };

  componentDidMount() {
    if (this.props.currentSite && this.props.currentSite.id) {
      this.props.clearTags();
      const pageNumber = this.state.page + 1;
      let apiFilters = this.createFilters(this.props);
      this.props.getTags(this.props.currentSite.id, pageNumber, this.state.pageSize, this.getSearchText(this.props.filters), this.props.sorting, apiFilters);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!isEmpty(nextProps.bulkResults) && isEmpty(this.props.bulkResults)) {
      this.handleBulkUploadResult(nextProps.bulkResults);
    }

    if(this.props.paginatedDataCount !== nextProps.paginatedDataCount){
      this.setState({ totalRows: nextProps.paginatedDataCount});
    }
    
    if(this.props.filters !== nextProps.filters){
      let pageNumber =  0;
      let apiFilters = this.createFilters(nextProps);

      this.setState({ first: 0, page: pageNumber, pageValue: pageNumber + 1 });
      this.props.getTags(this.props.currentSite.id, ++pageNumber, this.state.pageSize, this.getSearchText(nextProps.filters), this.props.sorting, apiFilters);
    }

    if (this.props.sorting !== nextProps.sorting) {
      let pageNumber = 0;

      let apiFilters = this.createFilters(this.props);
      this.setState({ first: 0, page: pageNumber, pageNumber: pageNumber + 1 });
      this.props.getTags(this.props.currentSite.id, ++pageNumber, this.state.pageSize, this.getSearchText(this.props.filters), nextProps.sorting, apiFilters);
    }

    // Site Change
    if (this.props.currentSite !== nextProps.currentSite) {
      let pageNumber = 0;
      this.props.clearTags();
      this.setState({ first: 0, page: pageNumber, pageValue: pageNumber + 1 });
      this.props.getTags(nextProps.currentSite.id, 1, this.state.pageSize);
    }

    return true;
  }

  getSearchText = (filters) => {
    let searchStr=[];
    filters.map((filter)=>{
      if(filter.type === 'search') {
        searchStr.push(filter.value)
      }
      return filter;
    });
    return searchStr.join(' ');
  }

  createFilters = (props) => {
    let columnFilters = props.filters.filter(filter => filter.type === "column");
    let apiFilters = columnFilters.map(filter => {
      let a = {
        key: filter.sortField,
        value: filter.value
      };
      return a;
    });
    return apiFilters;    
  }

  addFilter = data => {
    if (data.type === FILTER_TYPE.SEARCH) {
      this.props.addFilter(data);
    } else {
      const filters = this.props.filters;
      const filterFound = filters.find(filter => filter.column && filter.column.toLowerCase() === data.column.toLowerCase());
      // Same filter selected
      if (filterFound && filterFound.value === data.value) {
        return;
      }
      if (filterFound) {
        this.setState({ filterToAdd: data, filterChangeText: `replace '${filterFound.value}' with '${data.value}'`, showFilterConfirmationModal: true });
      } else {
        this.props.addFilter(data);
      }
    }
  };

  handleExport = () => {
    const queryParams = {
      searchText:this.getSearchText(this.props.filters),
      sorting:this.props.sorting,
      filters:this.createFilters(this.props),
      format:'csv',
      groupBy:'none'
    };
    this.props.downloadTagList(this.props.currentSite.id, queryParams);
  };

  expandCollapseRow = (tagId) => {
    this.props.expandTag(tagId);
  };

  handleAdd = () => {
    this.setState({ showAddModal: true });
  };

  handleAddSelection = ({ value }) => {
    this.props.setCurrentTag({});
    this.props.setCurrentCategory({});
    this.props.setCurrentGroup({});
    this.setState({ showAddModal: false, [`showAdd${value}Modal`]: true });
  };

  handleEditSelection = ({ value }) => {
    this.props.getFilteredCategories();
    this.props.getFilteredGroups();

    this.props.setCurrentTag({});
    this.props.setCurrentGroup({});
    this.setState({ showAddModal: false, [`showEdit${value}Modal`]: true });
  };

  handleAddTagSubmit = values => {
    values.account = this.props.account;
    values.site = this.props.currentSite;
    this.props.addTag(values);
    this.handleAddClose();
  };

  handleEditTagSubmit = values => {
    values.account = this.props.account;
    values.site = this.props.currentSite;
    this.props.editTag(values);
    this.handleAddClose();
  };

  handleDeleteTag = () => {
    this.setState({ showDeleteTagModal: true });
    this.handleAddClose();
  };

  handleBulkUpload = values => {
    this.props.bulkUploadClear();
    if (values.file) {
      URL.revokeObjectURL(values.file.preview);
    }
    this.props.addInfo("Bulk upload in progress");
    this.props.bulkUpload(values.file[0], this.props.currentSite.id);
  };

  handleBulkResultsClose = () => {
    this.setState({
      showResultsBulkUploadModal: false
    });
    this.props.getAreas(this.props.currentSite.id, true, this.props.account);
  };

  handleAddGroupSubmit = values => {
    const group = {
      account: this.props.account,
      name: values.name,
      site: this.props.currentSite.id
    };
    this.props.addGroup(group);
    this.handleAddClose();
  };

  handleEditGroupSubmit = value => {
    this.props.editGroup(value);
    this.handleAddClose();
  };

  handleDeleteGroup = () => {
    this.setState({ showDeleteGroupModal: true });
    this.handleAddClose();
  };

  handleAddCategory = values => {
    const category = {
      account: this.props.account,
      name: values.name,
      site: this.props.currentSite.id
    };
    this.props.addCategory(category);
    this.handleAddClose();
  };

  handleEditCategorySubmit = values => {
    this.props.editCategory(values);
    this.handleAddClose();
  };

  handleDeleteCategory = () => {
    this.setState({ showDeleteCategoryModal: true });
    this.handleAddClose();
  };

  handleDeleteTagConfirm = () => {
    this.props.deleteTag(
      {
        ...this.props.currentTag,
        site: this.props.currentSite,
        account: this.props.account
      },
      this.props.currentArea.id
    );
    this.handleDeleteClose();
  };

  handleCategorySearchChange = e => {
    this.setState({ categorySearchValue: e.currentTarget.value });
  };

  handleCategorySearch = (e) => {
    if ((e.charCode || e.keyCode) === 13) {
      this.props.getFilteredCategories(this.state.categorySearchValue);      
    }
  }

  handleEditCategory = value => {
    this.props.setCurrentCategory(value);
    this.setState({
      showEditCategoryListModal: false,
      showEditCategoryModal: true
    });
  };

  handleGroupSearchChange = e => {
    this.setState({ groupSearchValue: e.currentTarget.value });
  };

  handleGroupSearch = (e) => {
    if ((e.charCode || e.keyCode) === 13) {
      this.props.getFilteredGroups(this.state.groupSearchValue);      
    }
  }

  handleEditGroup = value => {
    this.props.setCurrentGroup(value);
    this.setState({
      showEditGroupListModal: false,
      showEditGroupModal: true
    });
  };

  handleDeleteGroupConfirm = () => {
    this.props.deleteGroup(this.props.currentGroup.id);
    this.handleDeleteClose();
  };

  handleDeleteCategoryConfirm = value => {
    const category = {
      id: this.props.currentCategory.id,
      categoryReplacement: value.category
    };
    this.props.deleteCategory(category);
    this.handleDeleteClose();
  };

  handleBulkUploadResult = () => {
    this.handleAddClose();
    this.setState({ showResultsBulkUploadModal: true });
  };

  onEdit = tag => {
    this.props.setCurrentTag(tag);
    this.setState({ showEditTagModal: true });
  };

  handleDeleteClose = () => {
    this.setState({
      showDeleteTagModal: false,
      showEditTagModal: false,
      showDeleteGroupModal: false,
      showDeleteCategoryModal: false
    });
  };

  handleAddClose = () => {
    this.setState({
      showAddModal: false,
      showAddTagModal: false,
      showEditTagModal: false,
      showAddGroupModal: false,
      showAddCategoryModal: false,
      showAddBulkUploadModal: false,
      showResultsBulkUploadModal: false,
      showEditCategoryListModal: false,
      showEditCategoryModal: false,
      showEditGroupListModal: false,
      showEditGroupModal: false
    });
  };

  handleFilterConfirmationConfirm = () => {
    this.props.addFilter(this.state.filterToAdd);
    this.setState({ filterToAdd: {}, filterChangeText: '', showFilterConfirmationModal: false });
  }

  handleFilterConfirmationClose = () => {
    this.setState({ filterToAdd: {}, filterChangeText: '', showFilterConfirmationModal: false });
  }

  setSorting = data => {
    this.props.setSorting(data);
  };

  goToMapView = () => {
    this.setCurrentAreaAndTag();
    this.props.history.push('/map');
  }

  setCurrentAreaAndTag = (selectedTag) => {
    this.props.selectTag(selectedTag ? selectedTag.id : null);
    let tagArea;
    if (this.props.tagsData.length) {
      selectedTag = selectedTag || this.props.tagsData[0];
      tagArea = this.props.areas.find(area => area.id === selectedTag.areaId);
    }
    tagArea = tagArea || this.props.areas[0];
    this.props.setCurrentArea(tagArea, true);
  };

  onRefresh = () => {
    let apiFilters = this.createFilters(this.props);
    this.props.getTags(this.props.currentSite.id, this.state.page, this.state.pageSize, this.getSearchText(this.props.filters), this.props.sorting, apiFilters);
  };

  selectTag = tagId => {
    if (tagId === this.props.selectedTag) {
      this.props.selectTag(null);
      return;
    }
    let tags = this.props.tagsData;
    let selectedTag = tags.find(tag => tag.id === tagId);
    this.setCurrentAreaAndTag(selectedTag);
    this.props.history.push('/map');
  };

  onPageChange(event) {
    if (this.state.page === event.page) {
      return;
    }
    this.setState({ first: event.first, page: event.page, pageValue: event.page + 1 });
    let apiFilters = this.createFilters(this.props);
    this.props.getTags(this.props.currentSite.id, ++event.page, this.state.pageSize, this.getSearchText(this.props.filters), this.props.sorting, apiFilters);
  }

  // todo remove
  handleFilter = (column) => {
    if (['field1', 'field2', 'battery'].indexOf(column.accessor) > -1) {
      
    }
  }

  handleCustomPageChange = (event) => {
    this.setState({ pageValue: event.target.value });
  }

  handleCustomPageChangeEnter = (e) => {
    if ((e.charCode || e.keyCode) === 13) {
      this.onCustomPageChange();    
    }
  }
  
  onCustomPageChange = () => {
    const totalPagesAvailable = Math.ceil(this.state.totalRows / this.state.pageSize);
    if(this.state.pageValue < 1 || this.state.pageValue > totalPagesAvailable){
      this.setState({ pageValue: this.state.page + 1});
      return;
    }
    const first  = (this.state.pageValue - 1) * this.state.pageSize;
    this.setState({ first: first, page: this.state.pageValue - 1 });

    let apiFilters = this.createFilters(this.props);
    this.props.getTags(this.props.currentSite.id, this.state.pageValue, this.state.pageSize, this.getSearchText(this.props.filters), this.props.sorting, apiFilters);
  }

  render() {
    if (!this.props.sitesLoading && !this.props.sitesList.length) {
      return <Redirect to='/no-sites-found' />;
    }
    return (
      <Fragment>
        <ErrorBoundary>
          <LoadingMask show={this.props.loading} />
          <DataTable
            styles={styles.list}
            columns={this.props.listViewColumns}
            data={this.props.tagsData}
            filteredBy={this.props.filters}
            addFilter={this.addFilter}
            removeFilter={this.props.removeFilter}
            onRowClick={this.selectTag}
            selectedRow={this.props.selectedTag}
            onEdit={this.onEdit}
            onExport={this.handleExport}
            onRowExpand={this.expandCollapseRow}
            tagsCount={this.props.paginatedDataCount}
            onSort={this.setSorting}
            listView={true}
            sorting={this.props.sorting}
            goToMapView={this.goToMapView}
            onRefresh={this.onRefresh}
            onFilterOpen={this.handleFilter}
            />
          <AddButton onClick={this.handleAdd} styles={styles.addButton} />
          <div className={`customPagination ${css(styles.customPagination)}`}>
            <div className={css(styles.customPaginationWrap)}>
              <Paginator
                totalRecords={this.state.totalRows}
                first={this.state.first}
                rows={this.state.rows}
                className={css(styles.paginator)}
                onPageChange={this.onPageChange.bind(this)}
              ></Paginator>
              <div>
                <Button
                  styles={[
                    styles.button
                  ]}
                  onClick={this.onCustomPageChange}
                ><Translate value="goto" /></Button>
                <input type="number"
                  className={css(styles.paginatorNumber)}
                  value={this.state.pageValue}
                  onChange={this.handleCustomPageChange}
                  onKeyPress={this.handleCustomPageChangeEnter} />
                <label className={css(styles.showingResults)}> of {Math.ceil(this.state.totalRows / this.state.pageSize) || 1}
                </label>
              </div>
            </div>
          </div>
        </ErrorBoundary>
        <Modal
          isOpen={this.state.showAddModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Add Modal"
          title={I18n.t('add.add')}
        >
          <ModalTabView>
            <ModalTabPanel header="Add">
              <AddSelection
                onClick={this.handleAddSelection}
                options={[
                  {
                    name: I18n.t('add.addTag'),
                    value: 'Tag',
                    iconType: ICON_TYPE.SVG,
                    iconValue: 'tag'
                  },
                  {
                    name: I18n.t('add.addGroup'),
                    value: 'Group',
                    iconType: ICON_TYPE.SVG,
                    iconValue: 'server'
                  },
                  {
                    name: I18n.t('add.addCategory'),
                    value: 'Category',
                    iconType: ICON_TYPE.SVG,
                    iconValue: 'briefcase'
                  },
                  {
                    name: I18n.t('add.bulkUpload.title'),
                    value: 'BulkUpload',
                    iconType: ICON_TYPE.LINEAR,
                    iconValue: 'upload'
                  }
                ]}
              />
            </ModalTabPanel>
            <ModalTabPanel header="Edit">
              <AddSelection
                onClick={this.handleEditSelection}
                options={[
                  {
                    name: I18n.t('edit.category.category'),
                    value: 'CategoryList',
                    iconType: ICON_TYPE.SVG,
                    iconValue: 'briefcase'
                  },
                  {
                    name: I18n.t('edit.group.group'),
                    value: 'GroupList',
                    iconType: ICON_TYPE.SVG,
                    iconValue: 'server'
                  }
                ]}
              />
            </ModalTabPanel>
          </ModalTabView>
        </Modal>
        <Modal
            isOpen={this.state.showAddTagModal || this.state.showEditTagModal}
            onRequestClose={this.handleAddClose}
            contentLabel={
              this.state.showAddTagModal ? 'Add Tags Modal' : 'Edit Tags Modal'
            }
            title={I18n.t(
              this.state.showAddTagModal ? 'add.tag.title' : 'edit.tag.title'
            )}
          >
            <AddTagForm
              onSubmit={
                this.state.showAddTagModal
                  ? this.handleAddTagSubmit
                  : this.handleEditTagSubmit
              }
              categories={this.props.categories}
              groups={this.props.groups}
              initialValues={this.props.currentTag}
              isEditing={this.state.showEditTagModal}
              onDelete={this.handleDeleteTag}
              onCancel={this.handleAddClose}
            />
          </Modal>
        <Modal
          isOpen={this.state.showAddBulkUploadModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Bulk Upload Modal"
          title={I18n.t('add.bulkUpload.title')}
        >
          <BulkUploadFileForm
            onSubmit={this.handleBulkUpload}
            onCancel={this.handleAddClose}
          />
        </Modal>
        <Modal
          isOpen={
            this.state.showResultsBulkUploadModal &&
            'recordCount' in this.props.bulkResults
          }
          onRequestClose={this.handleBulkResultsClose}
          contentLabel="Bulk Upload Results Modal"
          title={I18n.t('add.bulkUpload.resultsTitle')}
        >
          <BulkUploadResults {...this.props.bulkResults} />
        </Modal>
        <Modal
          isOpen={this.state.showAddGroupModal || this.state.showEditGroupModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Add Groups"
          title={I18n.t(
            this.state.showAddGroupModal
              ? 'add.group.title'
              : 'edit.group.title'
          )}
        >
          <AddGroupForm
            onSubmit={
              this.state.showAddGroupModal
                ? this.handleAddGroupSubmit
                : this.handleEditGroupSubmit
            }
            initialValues={this.props.currentGroup}
            isEditing={this.state.showEditGroupModal}
            onDelete={this.handleDeleteGroup}
            onCancel={this.handleAddClose}
          />
        </Modal>
        <Modal
          isOpen={
            this.state.showAddCategoryModal || this.state.showEditCategoryModal
          }
          onRequestClose={this.handleAddClose}
          contentLabel="Add Category"
          title={I18n.t(
            this.state.showAddCategoryModal
              ? 'add.category.title'
              : 'edit.category.title'
          )}
        >
          <AddCategoryForm
            onSubmit={
              this.state.showAddCategoryModal
                ? this.handleAddCategory
                : this.handleEditCategorySubmit
            }
            initialValues={this.props.currentCategory}
            isEditing={this.state.showEditCategoryModal}
            onDelete={this.handleDeleteCategory}
            onCancel={this.handleAddClose}
          />
        </Modal>
        <Modal
          isOpen={this.state.showDeleteTagModal}
          onRequestClose={this.handleDeleteClose}
          contentLabel="Delete Tag"
          title={I18n.t('delete.deleteTag')}
        >
          <Confirm
            itemName={this.props.currentTag && this.props.currentTag.name}
            confirm={this.handleDeleteTagConfirm}
            deny={this.handleDeleteClose}
          />
        </Modal>
        <Modal
          isOpen={this.state.showEditCategoryListModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Edit Category List"
          title={I18n.t('edit.category.title')}
        >
          <div className={css(styles.editList)}>
            <SearchInput
                styles={{
                  base: styles.searchBase,
                }}
                onChange={this.handleCategorySearchChange}
                onKeyPress={this.handleCategorySearch}
              />
            <ListItems
              onClick={this.handleEditCategory}
              noItemsMesagge={I18n.t('edit.category.noCategoriesFound')}
              list={this.props.searchedCategories}
            />
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showEditGroupListModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Edit Group List"
          title={I18n.t('edit.group.title')}
        >
          <div className={css(styles.editList)}>
            <SearchInput
                  styles={{
                    base: styles.searchBase
                  }}
                  onChange={this.handleGroupSearchChange}
                  onKeyPress={this.handleGroupSearch}
                />
            <ListItems
              onClick={this.handleEditGroup}
              noItemsMesagge={I18n.t('edit.group.noGroupsFound')}
              list={this.props.searchedGroups}
            />
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showDeleteGroupModal}
          onRequestClose={this.handleDeleteClose}
          contentLabel="Delete Group"
          title={I18n.t('delete.deleteGroup')}
        >
          <Confirm
            itemName={this.props.currentGroup && this.props.currentGroup.name}
            confirm={this.handleDeleteGroupConfirm}
            deny={this.handleDeleteClose}
          />
        </Modal>
        <Modal
          isOpen={this.state.showDeleteCategoryModal}
          onRequestClose={this.handleDeleteClose}
          contentLabel="Delete Category"
          title={I18n.t('delete.deleteCategory.title')}
        >
          <DeleteCategoryForm
            onSubmit={this.handleDeleteCategoryConfirm}
            deny={this.handleDeleteClose}
            itemName={
              this.props.currentCategory && this.props.currentCategory.name
            }
            itemId={this.props.currentCategory && this.props.currentCategory.id}
            categories={this.props.categories}
          />
        </Modal>
        <Modal
          isOpen={this.state.showFilterConfirmationModal}
          onRequestClose={this.handleFilterConfirmationClose}
          contentLabel="Confirm Filter"
          title="Confirm Filter"
        >
          <Confirmation
            itemName={this.state.filterChangeText}
            confirm={this.handleFilterConfirmationConfirm}
            deny={this.handleFilterConfirmationClose}
          />
        </Modal>
        <Notification message={this.props.notification} />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    areas,
    auth: { account },
    categories: { list: categories, currentCategory },
    groups: { list: groups, currentGroup },
    notifications: { notification },
    sites: {
      list: sitesList,
      currentSite,
      loading: sitesLoading
    },
    tags: { selected, currentTag, bulkResults, filters, sorting, totalPaginatedDataCount }
  } = state;
  const tagsData = getAllUnfilteredTags(state);
  const tagsCount = getTagsCount(state);
  const foundSelected = findSelectedTag(state);
  const searchedCategories = getFilteredCategories(state);
  const searchedGroups = getFilteredGroups(state);
  const paginatedDataCount = parseInt(totalPaginatedDataCount, 10);
  const listViewColumns = getListViewColumns(state);
  return {
    account,
    categories,
    currentCategory,
    currentGroup,
    currentSite,
    areas:
      currentSite &&
      currentSite.id in areas.map &&
      areas.map[currentSite.id],
    currentArea: areas.currentArea,
    selectedTag: foundSelected ? selected : null,
    currentTag,
    bulkResults,
    groups,
    filters,
    paginatedDataCount,
    loading: state.tags.loading,
    notification,
    searchedCategories,
    searchedGroups,
    sitesList,
    sitesLoading,
    sorting,
    tagsData,
    tagsCount,
    listViewColumns,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addFilter() {
      dispatch(addFilterAction(...arguments));
    },
    removeFilter() {
      dispatch(removeFilterAction(...arguments));
    },
    setSorting() {
      dispatch(setSortingAction(...arguments));
    },
    getTags() {
      dispatch(getTagsAction(...arguments));
    },
    setCurrentTag() {
      dispatch(setCurrentTagAction(...arguments));
    },
    setCurrentCategory() {
      dispatch(setCurrentCategoryAction(...arguments));
    },
    setCurrentGroup() {
      dispatch(setCurrentGroupAction(...arguments));
    },
    getFilteredCategories() {
      dispatch(getFilteredCategoriesAction(...arguments))
    },
    getFilteredGroups() {
      dispatch(getFilteredGroupsAction(...arguments))
    },
    addTag() {
      dispatch(addTagAction(...arguments));
    },
    editTag() {
      dispatch(editTagAction(...arguments));
    },
    bulkUploadClear() {
      dispatch(bulkUploadClearAction());
    },
    addInfo() {
      dispatch(addInfoAction(...arguments));
    },
    bulkUpload() {
      dispatch(bulkUploadAction(...arguments));
    },
    addGroup() {
      dispatch(addGroupAction(...arguments));
    },
    editGroup() {
      dispatch(editGroupAction(...arguments));
    },
    addCategory() {
      dispatch(addCategoryAction(...arguments));
    },
    editCategory() {
      dispatch(editCategoryAction(...arguments));
    },
    deleteTag() {
      dispatch(deleteTagAction(...arguments));
    },
    deleteGroup() {
      dispatch(deleteGroupAction(...arguments));
    },
    deleteCategory() {
      dispatch(deleteCategoryAction(...arguments));
    },
    getAreas() {
      dispatch(getAreasAction(...arguments));
    },
    setCurrentArea() {
      dispatch(setCurrentAreaAction(...arguments));
    },
    selectTag() {
      dispatch(selectTagAction(...arguments));
    },
    downloadTagList(){
      dispatch(downloadTagListAction(...arguments));
    },
    clearTags() {
      dispatch(clearTagsAction(...arguments));
    },
    expandTag() {
      dispatch(expandCollapseAction(...arguments));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);



// WEBPACK FOOTER //
// ./src/containers/list/List.js